import { Box, Button, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import { Equipment } from '@app/api/models';
import { Dialog, FieldView, Txt } from '@app/components/common';
import { entityBaseBodyRender, QueryTable } from '@app/components/common/table';
import { FieldComponentProps } from '@app/components/common/types';
import { useApi, useFetchData } from '@app/hooks';

export const EquipField = ({ value, onChange }: FieldComponentProps<Equipment>) => {
  const [open, setOpen] = useState(false);
  const api = useApi();
  const [fetchData] = useFetchData({ method: api.equipments.getEquipments });
  
  const onSelect = (equip: Equipment) => {
    
    onChange(equip);
    setOpen(false);
  };

  return <Box>
    <Txt color='gray.500'>Холодильное оборудование</Txt>
    <Flex justify='space-between' alignItems='center' w='100%'>
      <Flex alignItems='center' gap={4}>
        {!value && <Txt color='secondary.400'>Не выбрано</Txt>}
        {!!value && <> 
          <Txt>{value.model?.name}</Txt>
          <FieldView title="Инв.номер" value={value.inventory_num} />
          <FieldView title="Серийный номер" value={value.serial_num} />
        </>}
      </Flex>
      <Button variant='outline' colorScheme='brand' onClick={() => setOpen(true)}>Выбрать</Button>
    </Flex>
    <Dialog 
      title="Выбор ХО"  
      open={open} 
      onClose={() => 
      setOpen(false)} width="fit-content"
    >
      <Box mx={-6} mb={-10} mt={-5}>
        <QueryTable<Equipment>
          ignoreQuery
          onRowClick={onSelect} 
          title="" 
          columns={[
            { name: 'id', label: '#', options: { filter: true } },
            { name: 'model', label: 'Модель', options: { customBodyRender: entityBaseBodyRender() } },
            { name: 'inventory_num', label: 'Инв.номер', options: { 
              filter: {
                name: 'inventory_num',
                type: 'text', 
              }
            } },
            { name: 'serial_num', label: 'Серийный номер', options: { 
              filter: {
                name: 'serial_num',
                type: 'text', 
              }
            } }
          ]} 
          fetchData={fetchData}      
        />
      </Box>
    </Dialog>  
  </Box>;

};
